import { Configuration } from '@azure/msal-browser';
import { msalConfig as customConfig, cacheConfig, systemConfig } from './authConfig';

const msalConfig: Configuration = {
  auth: {
    clientId: customConfig.clientId,
    authority: customConfig.authority,
    knownAuthorities: [customConfig.knownAuthorities ? customConfig.knownAuthorities[0] : 'anagogia.b2clogin.com'],
    redirectUri: customConfig.redirectUri,
    postLogoutRedirectUri: customConfig.postLogoutRedirectUri,
  },
  cache: cacheConfig,
  system: systemConfig,
};

export default msalConfig;
